import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  useRetrieveResourceCalendarHolidays,
  useAssignCalendarHolidaysToResource,
  useUnAssignCalendarHolidaysFromResource,
  useRetrieveCalendarsHolidays,
} from "@planzone/view-models";
import {
  Identifiable,
  CalendarHolidays,
  calendarHolidays as calendar,
} from "@planzone/dto";
import { CalendarHolidaysSelection } from "./calendarHolidaysSelection";
import { Props } from "./types";
import styles from "./styles.scss";

function AssignCalendarHolidaysToResource({ planzone, resource }: Props) {
  const { t } = useTranslation();
  const {
    calendarsHolidays,
    isRequestFailure: isRetrieveCalendarsHolidaysFailure,
    isRequestPending: isRetrieveCalendarsHolidaysPending,
    isRequestSuccess: isRetrieveCalendarHolidaysSuccess,
    retrieveCalendarHolidays,
  } = useRetrieveCalendarsHolidays();
  const {
    isRequestFailure,
    isRequestPending,
    isRequestSuccess,
    calendarHolidays,
    retrieveResourceCalendarHolidays,
  } = useRetrieveResourceCalendarHolidays(resource);

  const {
    isRequestPending: isAssignRequestPending,
    assignCalendarHolidaysToResource,
  } = useAssignCalendarHolidaysToResource(resource);
  const { unAssignCalendarHolidaysFromResource } =
    useUnAssignCalendarHolidaysFromResource(resource);

  useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveResourceCalendarHolidays({ resource });
  }, [planzone, resource]);

  useEffect(() => {
    !isRetrieveCalendarsHolidaysFailure &&
      !isRetrieveCalendarsHolidaysPending &&
      !isRetrieveCalendarHolidaysSuccess &&
      retrieveCalendarHolidays(planzone);
  }, [planzone]);

  return (
    <div className={styles.calendarHolidaysContainer}>
      <div className={styles.calendarHolidaysGroup}>
        <div className={styles.calendarHolidaysWrapper}>
          <h2 className={styles.title}>
            {t("editResource.calendarHolidaysTitle")} :
          </h2>
          <CalendarHolidaysSelection
            placeholder={t("editResource.inputCalendarHolidays")}
            selectedCalendarHolidays={
              calendarHolidays && !!calendarHolidays.uuid
                ? calendarHolidays
                : null
            }
            calendarsHolidays={calendarsHolidays}
            isDisabled={isAssignRequestPending}
            select={(calendar: Identifiable<CalendarHolidays>) => {
              assignCalendarHolidaysToResource({
                resource: resource,
                calendarHolidays: calendar,
              });
            }}
            clearSelection={() => {
              unAssignCalendarHolidaysFromResource(resource);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export { AssignCalendarHolidaysToResource };
